<template>
    <div class="nomina">
        <div class="wait" v-if="createButton" alt="" :class="{'animation': animation}">
            <div>
                <img src="@/assets/imperium.gif">
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="pending" title="Agregar pendiente">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h1>Agregar Pendiente</h1>
                <select name="" id="" v-model="typePending">
                    <option v-for="(type, index) in pendingTypes" :value="type.name" :key="index">{{ type.name }}</option>
                </select>
                <input type="number" name="" id="" v-model="pendingTotal">
                <button @click="addPendingNomina()">Agregar Pendiente</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="egreso" title="Agregar egreso">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h1>Agregar Egreso</h1>
                <select name="" id="" v-model="typeEgreso">
                    <option v-for="(type, index) in egresoTypes" :value="type.name" :key="index">{{ type.name }}</option>
                </select>
                <input type="number" name="" id="" v-model="egresoTotal">
                <textarea name="" id="" cols="30" rows="10" v-model="egresoObs"></textarea>
                <button @click="addEgresoNomina()">Agregar Egreso</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="ingreso" title="Agregar ingreso">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h1>Agregar Ingreso</h1>
                <select name="" id="" v-model="typeIngreso">
                    <option v-for="(type, index) in ingresosTypes" :value="type.name" :key="index">{{ type.name }}</option>
                </select>
                <input type="number" name="" id="" v-model="ingresoTotal">
                <textarea name="" id="" cols="30" rows="10"></textarea>
                <button @click="addIngresoNomina()">Agregar Ingreso</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="anticipo" title="Agregar ingreso">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h1>Agregar Anticipo</h1>
                <label for="">Tipo de anticipo</label>
                <select name="" id="" v-model="typeAnticipo">
                    <option v-for="(type, index) in anticiposTypes" :value="type.name" :key="index">{{ type.name }}</option>
                </select>
                <label for="">Metodo de pago</label>
                <select name="" id="" v-model="typeMedio">
                    <option v-for="(type, index) in anticiposMedios" :value="type.name" :key="index">{{ type.name }}</option>
                </select>
                <input type="number" name="" id="" v-model="anticipoTotal">
                <button @click="addAnticipoNomina()">Agregar Anticipo</button>
            </div>
        </b-modal>
        <div class="modal-list" :class="{'display': !isOpenTienda}">
            <div>
                <h3 @click="isOpenTienda = false">X</h3>
                <center>
                    <h3>Generar venta manual</h3>
                </center>
                <span @click="change"><i class="fa-solid fa-arrow-left"></i></span>
                <div class="products-info">
                    <div class="category-list" v-if="!categorySelected && !isPedido">
                        <div v-for="(item, index) in categories" :key="index" @click="selectCategory(item)">
                            <label for="">{{ item.name }}</label>
                        </div>
                    </div>
                    <div class="products-list" v-if="categorySelected && !isPedido">
                        <div v-for="(item, index) in products" :key="index" @click="selectProduct(item)">
                            <center>
                                <img :src="item.image" alt="">
                                <h5>{{ item.name }}</h5>
                                <label for="">{{ priceFormat(item.price) }}</label>
                            </center>
                        </div>
                    </div>
                    <div class="list-pedido" v-if="isPedido">
                        <div v-for="(item, index) in ledgers_manual" :key="index">
                            <center>
                                <div><img :src="item.image" alt=""></div>
                                <div><h5>{{ item.name }}</h5></div>
                                <div><input type="number" v-model="item.cantidad"></div>
                                <div><label for="">{{ priceFormat(item.price * item.cantidad) }}</label></div>
                                <div><h4 @click="deleateManualLedger(index)">X</h4></div>
                            </center>
                        </div>
                        <button @click="addVentaNomina">AGREGAR VENTA</button>
                    </div>
                    <button @click="pedido()" v-if="!isPedido">Ver pedido</button>
                </div>
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="addTRM" title="Agregar TRM a la nomina">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Agregar TRM</h3>
                <input type="number" v-model="TRM_TO_SEND">
                <button @click="addTRM()">Agregar TRM</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="administrativa" title="Generar Nomina Administrativa">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Subir Nomina Administrativa</h3>
                <input type="file" ref="file_profiles" name="profiles" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                <button @click="importNominaAdmin()">Agregar Nuevo</button>
            </div>
        </b-modal>
        <center>
            <div v-if="isOpen" class="prenomina">
                <div class="close"><h4 @click="isOpen = false">X</h4></div>
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Ver</th>
                            <th>Sin previo</th>
                            <th>Photo</th>
                            <th>Modelo</th>
                            <th>Plataformas</th>
                            <th>Mecato</th>
                            <th>Jugueteria</th>
                            <th>Pendiente Jug</th>
                            <th>Variedades</th>
                            <th>Pendiente Var</th>
                            <th>Egresos</th>
                            <th>Pendiente Egresos</th>
                            <th>Ingresos</th>
                            <th>Bono</th>
                            <th>Total a pagar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in subnominas" :key="index" :class="{'modelo': item.user_type === 'Modelo', 'admin': item.user_type !== 'Modelo', 'no-pay': item.no_pay}">
                            <template v-if="item > 0">
                                <td colspan=13 v-if="userOpen === item" style="background-color: aquamarine;">
                                    <center>
                                        <button :class="{'active': optionSelect === 'platforms'}" @click="optionSelect='platforms'">Plataformas</button>
                                        <button :class="{'active': optionSelect === 'pendientes'}" @click="optionSelect='pendientes'">Pendientes</button>
                                        <button :class="{'active': optionSelect === 'egresos'}" @click="optionSelect='egresos'">Egresos</button>
                                        <button :class="{'active': optionSelect === 'jugueteria'}" @click="optionSelect='jugueteria'">Jugueteria</button>
                                        <button :class="{'active': optionSelect === 'variedades'}" @click="optionSelect='variedades'">Variedades</button>
                                        <button :class="{'active': optionSelect === 'mecato'}" @click="optionSelect='mecato'">Mecato</button>
                                        <button :class="{'active': optionSelect === 'ingresos'}" @click="optionSelect='ingresos'">ingresos</button>
                                        <button :class="{'active': optionSelect === 'anticipos'}" @click="optionSelect='anticipos'">Anticipos</button>
                                        <button :class="{'active': optionSelect === 'lastplatforms'}" @click="optionSelect='lastplatforms'">Ultimas ganancias</button>
                                        <table v-if="optionSelect === 'platforms'">
                                            <thead>
                                                <tr>
                                                    <th>DIA</th>
                                                    <th>Chaturbate</th>
                                                    <th>Stripchat</th>
                                                    <th>Camsoda</th>
                                                    <th>Bongacams</th>
                                                    <th>Skyprivate</th>
                                                    <th>TOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>TOTAL</td>
                                                    <td>{{ totalChaturbateLedgers }}</td>
                                                    <td>{{ totalStripchatLedgers }}</td>
                                                    <td>{{ totalCamsodaLedgers }}</td>
                                                    <td>{{ totalBongaCamsLedgers }}</td>
                                                    <td>{{ totalSkyprivateLedgers }}</td>
                                                    <td>{{ totalChaturbateLedgers + totalStripchatLedgers + totalSkyprivateLedgers + totalBongaCamsLedgers + totalCamsodaLedgers}}</td>
                                                </tr>
                                                <tr v-for="(ledger, index) in ledgers" :key="index">
                                                    <td>{{ ledger.date.split('T')[0] }}</td>
                                                    <td>{{ ledger.chaturbate }}</td>
                                                    <td>{{ ledger.stripchat }}</td>
                                                    <td>{{ ledger.camsoda }}</td>
                                                    <td>{{ ledger.bonga }}</td>
                                                    <td>{{ ledger.skyprivate }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table v-if="optionSelect === 'pendientes'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td>{{ priceFormat(totalPendings) }}</td>
                                                    <td></td>
                                                </tr>
                                                <tr v-for="(pending, index) in pendings" :key="index">
                                                    <td>{{ pending.type }}</td>
                                                    <td>{{ priceFormat(pending.valor) }}</td>
                                                    <td><h5 @click="detelePending(pending.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'pending')">Agregar Pendiente</button>
                                        </table>
                                        <table v-if="optionSelect === 'anticipos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Medio</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalAnticipos) }}</td>
                                                </tr>
                                                <tr v-for="(anticipo, index) in anticipos" :key="index">
                                                    <td>{{ anticipo.type }}</td>
                                                    <td>{{ anticipo.medio }}</td>
                                                    <td>{{ priceFormat(anticipo.valor) }}</td>
                                                    <td><h5 @click="deteleAnticipo(anticipo.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'anticipo')">Agregar Anticipos</button>
                                        </table>
                                        <table v-if="optionSelect === 'egresos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Motivo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalEgresos) }}</td>
                                                </tr>
                                                <tr v-for="(egreso, index) in egresos" :key="index">
                                                    <td>{{ egreso.type }}</td>
                                                    <td>{{ egreso.motivo }}</td>
                                                    <td>{{ priceFormat(egreso.valor) }}</td>
                                                    <td><h5 @click="deleteEgreso(egreso.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'egreso')">Agregar Egreso</button>
                                        </table>
                                        <table v-if="optionSelect === 'jugueteria'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalJugueterias) }}</td>
                                                </tr>
                                                <tr v-for="(juguete, index) in jugueteria" :key="index">
                                                    <td>{{ juguete.name }}</td>
                                                    <td>{{ juguete.category }}</td>
                                                    <td>{{ juguete.cant }}</td>
                                                    <td>{{ priceFormat(juguete.total) }}</td>
                                                    <td v-if="juguete.status === 0"><h5 @click="deleteVenta(juguete.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Jugueteria</button>
                                        </table>
                                        <table v-if="optionSelect === 'variedades'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalVariedades) }}</td>
                                                </tr>
                                                <tr v-for="(variedad, index) in variedades" :key="index">
                                                    <td>{{ variedad.name }}</td>
                                                    <td>{{ variedad.category }}</td>
                                                    <td>{{ variedad.cant }}</td>
                                                    <td>{{ priceFormat(variedad.total) }}</td>
                                                    <td v-if="variedad.status === 0"><h5 @click="deleteVenta(variedad.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Variedades</button>
                                        </table>
                                        <table v-if="optionSelect === 'mecato'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalMecatos) }}</td>
                                                </tr>
                                                <tr v-for="(meca, index) in mecato" :key="index">
                                                    <td>{{ meca.name }}</td>
                                                    <td>{{ meca.category }}</td>
                                                    <td>{{ meca.cant }}</td>
                                                    <td>{{ priceFormat(meca.total) }}</td>
                                                    <td v-if="meca.status === 0"><h5 @click="deleteVenta(meca.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Mecato</button>
                                        </table>
                                        <table v-if="optionSelect === 'ingresos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Motivo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalIngresos) }}</td>
                                                </tr>
                                                <tr v-for="(egreso, index) in ingresos" :key="index">
                                                    <td>{{ egreso.type }}</td>
                                                    <td>{{ egreso.motivo }}</td>
                                                    <td>{{ priceFormat(egreso.valor) }}</td>
                                                    <td><h5 @click="deleteIngreso(egreso.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'ingreso')">Agregar Ingreso</button>
                                        </table>
                                        <table v-if="optionSelect === 'lastplatforms'">
                                            <thead>
                                                <tr>
                                                    <th>DIA</th>
                                                    <th>Chaturbate</th>
                                                    <th>Stripchat</th>
                                                    <th>Camsoda</th>
                                                    <th>Bongacams</th>
                                                    <th>Skyprivate</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>TOTAL</td>
                                                    <td>{{ lastTotalChaturbateLedgers }}</td>
                                                    <td>{{ lastTotalStripchatLedgers }}</td>
                                                    <td>{{ lastTotalCamsodaLedgers }}</td>
                                                    <td>{{ lastTotalBongaCamsLedgers }}</td>
                                                    <td>{{ lastTotalSkyprivateLedgers }}</td>
                                                    <td>{{ lastTotalChaturbateLedgers + lastTotalStripchatLedgers + lastTotalCamsodaLedgers + lastTotalBongaCamsLedgers + lastTotalSkyprivateLedgers}}</td>
                                                </tr>
                                                <tr v-for="(ledger, index) in lastLedgers" :key="index">
                                                    <td>{{ ledger.date.split('T')[0] }}</td>
                                                    <td>{{ ledger.chaturbate }}</td>
                                                    <td>{{ ledger.stripchat }}</td>
                                                    <td>{{ ledger.camsoda }}</td>
                                                    <td>{{ ledger.bonga }}</td>
                                                    <td>{{ ledger.skyprivate }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </center>
                                </td>
                            </template>
                            <template v-else>
                                <td>{{ ++index/2 + 0.5 }}</td>
                                <td><button @click="openDetails(item.uid)">></button></td>
                                <td><input type="checkbox" name="" id="" v-model="item.preaviso" @change="changePorcentage(item.uid)"></td>
                                <td><img :src="item.photo" alt=""></td>
                                <td>{{ item.user }}</td>
                                <td v-if="item.user_type === 'Modelo' || (item.user_type !== 'Modelo' && trm === null)">{{ priceFormat(item.total_plataformas + item.bono_dolar) }}</td>
                                <td v-if="item.user_type !== 'Modelo' && trm !== null"><input type="number" v-model="item.total_plataformas"></td>
                                <td>{{ priceFormat(item.mecato) }}</td>
                                <td v-if="item.jugueteria === 0">{{ priceFormat(item.jugueteria) }}</td>
                                <td v-else><input type="number" :min="0" :max="item.jugueteria" v-model="item.jugueteria"></td>
                                <td>{{ priceFormat(((item.pay_jugueteria - item.jugueteria))) }}</td>
                                <td v-if="item.variedades === 0">{{ priceFormat(item.variedades) }}</td>
                                <td v-else><input type="number" :min="0" :max="item.variedades" v-model="item.variedades"></td>
                                <td>{{ priceFormat((item.pay_variedades - item.variedades)) }}</td>
                                <td v-if="item.multas_total === 0">{{ priceFormat(item.multas_total) }}</td>
                                <td v-else><input type="number" :min="0" :max="item.multas_total" v-model="item.multas_total"></td>
                                <td>{{ priceFormat((item.pay_egresos - item.multas_total)) }}</td>
                                <td>{{ priceFormat(item.ingresos) }}</td>
                                <td v-if="item.bonos === 0 || item.user_type === 'Modelo'" >{{ priceFormat(item.bono_pesos) }}</td>
                                <td v-else><input type="number" :min="0" :max="item.bonos"  v-model="item.bonos"></td>
                                <td v-if="item.user_type === 'Modelo'">{{ priceFormat(parseFloat((item.bono_dolar * trm) + item.ingresos + parseFloat(item.bono_pesos) + parseFloat(item.total_plataformas * trm) - (parseFloat(item.jugueteria) + parseFloat(item.multas_total) + parseFloat(item.mecato) + parseFloat(item.variedades)))) }}</td>
                                <td v-else>{{ priceFormat(parseFloat(item.bonos) + parseFloat(item.total_plataformas) - (parseFloat(item.jugueteria) + parseFloat(item.multas_total) + parseFloat(item.mecato) + parseFloat(item.variedades)) + item.ingresos) }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <button @click="repairNomina()">Reparar</button>
                    <button v-if="trm === null" @click="$refs.addTRM.show()">Agregar TRM</button>
                    <button v-if="trm !== null" @click="EditarNomina()">Editar</button>
                    <button v-if="trm != null && status === 'proccess'" @click="CerrarNomina()">Finalizar Nomina</button>
                    <button v-if="exportConsolidadoStatus" @click="Consolidado()">Generar consolidado Bonificaciones</button>
                    <button v-if="!exportConsolidadoStatus"><a :href="consolidado_link" @click="exportModelsStatus = true">Descargar consolidado Bonificaciones</a></button>
                    <button v-if="trm != null && status === 'completed'" @click="$refs.administrativa.show()">Nomina Administrativa</button>
                </div>
            </div>
        </center>
        <div class="notifications">
            <div class="table">
                <center>
                    <h3>Nominas</h3>
                    <div v-for="(item, index) in nominas" :key="index" @click="selectedNomina(index)" :class="{'select': item.select}">
                        <label class="border-label" style="width: 100px">{{ item.id }}</label>
                        <label class="border-label" style="width: 400px">{{item.status}}</label>
                        <label class="border-label">{{item.trm === null ? 'Sin definir' : item.trm}}</label>
                        <label>{{item.tipo}}</label>
                    </div>
                </center>
            </div>
            <div class="details">
                <div>
                    <div>
                        <label for="">Total plataformas: <span>{{priceFormat(totalPlataformas)}}</span></label>
                        <label for="">Tienda Mecato: <span>{{priceFormat(mecato)}}</span></label>
                        <label for="">Tienda Jugueteria: <span>{{priceFormat(jugueteria)}}</span></label>
                        <label for="">Tienda variedades: <span>{{priceFormat(variedades)}}</span></label>
                    </div>
                    <div>
                        <label for="">Bonos Admistradores: <span>{{priceFormat(adminBonos)}}</span></label>
                        <label for="">Bonos monitores: <span>{{priceFormat(monitorBonos)}}</span></label>
                        <label for="">Bonos Modelos P$: <span>{{priceFormat(bono_pesos)}}</span></label>
                        <label for="">Bono modelo D$: <span>{{priceFormat(bono_dolar)}}</span></label>
                    </div>
                    <div>
                        <label for="">TRM: <span>{{trm == null ? 'Sin definir' : priceFormat(trm)}}</span></label>
                        <label for="">Pendientes: <span>{{pendientes}}</span></label>
                        <label for="">Bono modelos total: <span>{{modelBonos}}</span></label>
                        <label for="">Fecha nomina: <span>{{intervalDate}}</span></label>
                    </div>
                </div>
            </div>
        </div>
        <div class="models">
            <div class="list">
                <div v-for="(item, index) in subnominas" :key="index" @click="openPDF(item.pdf)" v-if="typeof item === 'object'">
                    <img :src="item.photo" alt="">
                    <div>
                        <label for="">{{ item.user }}</label>
                    </div>
                    <label ><span :class="{'vista': item.status === 'vista', 'entregada': item.status === 'entregada'}">{{item.status}}</span></label>
                </div>
            </div>
            <div class="functions">
                <div>
                    <div v-if="nomina_id !== null">
                        <button @click="isOpen = true">Ver nomina</button>
                    </div>
                    <div v-if="status !== 'create'">
                        <button :disabled="createButton" @click="createNomina">Crear nomina</button>
                    </div>
                    <div v-if="status !== 'proccess' && status !== 'completed'">
                        <button @click="processNomina">Procesar nomina</button>
                    </div>
                </div>
                <div>
                    <div v-if="status === 'completed'">
                        <button><a :href="nomina_link">Descargar Nomina</a></button>
                    </div>
                    <div v-if="status === 'completed'">
                        <button @click="sendNomina()">Actualizar nomina</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notify from '@/utils/Notification.js'
import API from '@/api'
import Price from '../utils/ConvertPriceNumber'

export default {
    data() {
        return {
            subnominas: [],
            nominas: [],
            limit: 30,
            offset: 0,
            index: 0,
            totalPlataformas: null,
            mecato_total: null,
            jugueteria_total: null,
            variedades_total: null,
            bono_pesos: null,
            bono_dolar: null,
            egresos_total: null,
            adminBonos: null,
            pendientes: null,
            modelBonos: null,
            monitorBonos: null,
            trm: null,
            status: null,
            nomina_id: null,
            nomina_link: null,
            back_index: -1,
            isOpen: false,
            TRM_TO_SEND: null,
            intervalDate: null,
            userOpen: null,
            optionSelect: 'platforms',
            ledgers: [],
            pendings: [],
            anticipos: [],
            egresos: [],
            jugueteria: [],
            variedades: [],
            mecato: [],
            lastLedgers: [],
            pendingTypes: [],
            egresoTypes: [],
            ingresosType: [],
            categories: [],
            products: [],
            isOpenTienda: false,
            typePending: null,
            isPedido: false,
            categorySelected: false,
            pendingTotal: 0,
            categoryId: null,
            ledgers_manual: [],
            uid_add: null,
            typeEgreso: null,
            egresoTotal: 0,
            subnomina_open: {},
            totalChaturbateDolars: 0,
            totalBongaCamsDolars: 0,
            totalCamsodaDolars: 0,
            totalSkyprivateDolars: 0,
            totalStripchatDolars: 0,
            ingresos: [],
            typeIngreso: null,
            ingresosTypes: [],
            anticiposTypes: [],
            anticiposMedios: [],
            typeAnticipo: null,
            typeMedio: null,
            anticipoTotal: null,
            egresoObs: null,
            ingresoTotal: 0,
            createButton: false,
            animation: false,
            consolidado_link: null,
            exportConsolidadoStatus: true
        }
    },
    computed: {
        totalMecatos: {
            get() {
                if (this.mecato.length === 0) {
                    return 0
                }
                return this.mecato.reduce((accumulator, object) => {
                    return accumulator + object.total
                }, 0)
            }
        },
        totalVariedades: {
            get() {
                if (this.variedades.length === 0) {
                    return 0
                }
                return this.variedades.reduce((accumulator, object) => {
                    return accumulator + object.total
                }, 0)
            }
        },
        totalJugueterias: {
            get() {
                if (this.jugueteria.length === 0) {
                    return 0
                }
                return this.jugueteria.reduce((accumulator, object) => {
                    return accumulator + object.total
                }, 0)
            }
        },
        totalEgresos: {
            get() {
                return this.egresos.reduce((accumulator, object) => {
                    return accumulator + object.valor
                }, 0)
            }
        },
        totalIngresos: {
            get() {
                return this.ingresos.reduce((accumulator, object) => {
                    return accumulator + object.valor
                }, 0)
            }
        },
        totalPendings: {
            get() {
                return this.pendings.reduce((accumulator, object) => {
                    return accumulator + object.valor
                }, 0)
            }
        },
        totalAnticipos: {
            get() {
                return this.anticipos.reduce((accumulator, object) => {
                    return accumulator + object.valor
                }, 0)
            }
        },
        totalChaturbateLedgers: {
            get() {
                return this.ledgers.reduce((accumulator, object) => {
                    if (object.chaturbate) {
                        return accumulator + object.chaturbate
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        totalStripchatLedgers: {
            get() {
                return this.ledgers.reduce((accumulator, object) => {
                    if (object.stripchat) {
                        return accumulator + object.stripchat
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        totalCamsodaLedgers: {
            get() {
                return this.ledgers.reduce((accumulator, object) => {
                    if (object.camsoda) {
                        return accumulator + object.camsoda
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        totalBongaCamsLedgers: {
            get() {
                return this.ledgers.reduce((accumulator, object) => {
                    if (object.bonga) {
                        return accumulator + object.bonga
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        totalSkyprivateLedgers: {
            get() {
                return this.ledgers.reduce((accumulator, object) => {
                    if (object.skyprivate) {
                        return accumulator + object.skyprivate
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        lastTotalChaturbateLedgers: {
            get() {
                return this.lastLedgers.reduce((accumulator, object) => {
                    if (object.chaturbate) {
                        return accumulator + object.chaturbate
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        lastTotalStripchatLedgers: {
            get() {
                return this.lastLedgers.reduce((accumulator, object) => {
                    if (object.stripchat) {
                        return accumulator + object.stripchat
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        lastTotalCamsodaLedgers: {
            get() {
                return this.lastLedgers.reduce((accumulator, object) => {
                    if (object.camsoda) {
                        return accumulator + object.camsoda
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        lastTotalBongaCamsLedgers: {
            get() {
                return this.lastLedgers.reduce((accumulator, object) => {
                    if (object.bonga) {
                        return accumulator + object.bonga
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        lastTotalSkyprivateLedgers: {
            get() {
                return this.lastLedgers.reduce((accumulator, object) => {
                    if (object.skyprivate) {
                        return accumulator + object.skyprivate
                    } else {
                        return accumulator + 0
                    }
                }, 0)
            }
        },
        createNominaDate: {
            get() {
                var date = new Date()
                return (date.getDate() > 1 && date.getDate() < 5) || (date.getDate() > 15 && date.getDate() < 20)
            }
        }
    },
    methods: {
        changePorcentage(uid) {
            API.changePorcentage(uid, this.nomina_id)
                .then((res) => {
                    console.log(res)
                })
        },
        importNominaAdmin() {
            API.importNominaAdmin(this.$refs.file_profiles.files[0], this.nomina_id)
                .then((res) => {
                    this.getNominas()
                    this.$refs.administrativa.hide()
                })
        },
        repairNomina() {
            API.repairNomina(this.nomina_id)
                .then((res) => {
                    this.getNominas()
                })
        },
        Consolidado() {
            API.getConsolidadoBonificaciones(this.nomina_id)
                .then((res) => {
                    this.consolidado_link = res.link
                    this.exportConsolidadoStatus = false
                })
        },
        openPDF(pdf) {
            window.open(pdf, '_blank')
        },
        sendNomina() {
            API.sendNomina(this.nomina_id)
                .then((res) => {
                    Notify('dirty', 'Se esta enviado la nomina')
                })
        },
        processNomina() {
            API.processNomina(this.nomina_id)
                .then((res) => {
                    this.getNominas()
                })
        },
        createNomina() {
            this.createButton = true
            this.animation = true
            API.createNomina()
            setTimeout(() => {
                this.getNominas()
                this.intro = false
                this.createButton = false
            }, 30000)
        },
        deleateManualLedger(index) {
            this.ledgers_manual.splice(index, 1)
            if (this.ledgers_manual <= 0) {
                this.isPedido = false
            }
        },
        pedido() {
            this.isPedido = true
        },
        selectProduct(item) {
            var info = {
                id: item.id,
                cantidad: 1,
                image: item.image,
                name: item.name,
                price: item.price
            }
            this.ledgers_manual.push(info)
            Notify('dirty', 'Se agrego ' + item.name + 'a la lista de pedidos')
        },
        selectCategory(item) {
            this.products = []
            this.categories.map(model => { model.select = false })
            API.Store.getProductsListByCategory(item.name)
                .then((res) => {
                    this.products = res
                    item.select = true
                    this.categoryId = item.id
                    this.categorySelected = true
                })
        },
        getCategoriesList() {
            API.Store.getCategories()
                .then((res) => {
                    this.categories = res
                })
        },
        change() {
            if (this.isPedido) {
                this.isPedido = !this.isPedido
                this.categorySelected = false
                return
            }
            if (this.categorySelected) {
                this.categorySelected = !this.categorySelected
            }
        },
        addVentaNomina() {
            API.addVentaNomina(this.uid_add, this.nomina_id, this.ledgers_manual)
                .then((res) => {
                    if (res === false) {
                        Notify('error', 'No se genero la venta compurueba que la tienda esta abierta')
                        return
                    }
                    Notify('dirty', 'Se genero la venta para la modelo existosamente')
                    this.isOpenTienda = false
                    this.categoryId = null
                    this.categorySelected = false
                    this.products = []
                    this.ledgers_manual = []
                    this.isPedido = false
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    this.subnominas[index].jugueteria += parseFloat(res.jugueteria)
                    this.subnominas[index].variedades += parseFloat(res.variedades)
                    this.subnominas[index].pay_jugueteria += parseFloat(res.jugueteria)
                    this.subnominas[index].pay_variedades += parseFloat(res.variedades)
                    this.subnominas[index].mecato += parseFloat(res.mecato)
                    this.getJugueteria(this.uid_add)
                    this.getVariedades(this.uid_add)
                    this.getMecato(this.uid_add)
                })
        },
        addEgresoNomina() {
            API.addEgresoNomina(this.uid_add, this.nomina_id, {type: this.typeEgreso, total: this.egresoTotal, obs: this.egresoObs})
                .then((res) => {
                    Notify('dirty', 'Se agrego el egreso para la modelo')
                    this.$refs['egreso'].hide()
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    this.subnominas[index].multas_total += parseFloat(res.total)
                    this.subnominas[index].pay_egresos += parseFloat(res.total)
                    this.getEgresos(this.uid_add)
                })
        },
        addIngresoNomina() {
            API.addIngresoNomina(this.uid_add, this.nomina_id, {type: this.typeIngreso, total: this.ingresoTotal})
                .then((res) => {
                    Notify('dirty', 'Se agrego el ingreso para la modelo')
                    this.$refs['ingreso'].hide()
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    this.subnominas[index].ingresos += parseFloat(res.total)
                    this.getIngresos(this.uid_add)
                })
        },
        addPendingNomina() {
            API.addPendingNomina(this.uid_add, this.nomina_id, {type: this.typePending, total: this.pendingTotal})
                .then((res) => {
                    Notify('dirty', 'Se agrego el pendiente para la modelo')
                    this.$refs['pending'].hide()
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    if (this.typePending === 'jugueteria') {
                        this.subnominas[index].jugueteria += parseFloat(res.total)
                        this.subnominas[index].pay_jugueteria += parseFloat(res.total)
                    } else if (this.typePending === 'variedades') {
                        this.subnominas[index].variedades += parseFloat(res.total)
                        this.subnominas[index].pay_variedades += parseFloat(res.total)
                    } else if (this.typePending === 'egreso') {
                        this.subnominas[index].multas_total += parseFloat(res.total)
                        this.subnominas[index].pay_egresos += parseFloat(res.total)
                    }
                    this.getPendings(this.uid_add)
                })
        },
        addAnticipoNomina() {
            API.addAnticipoNomina(this.uid_add, this.nomina_id, {type: this.typeAnticipo, total: this.anticipoTotal, medio: this.typeMedio})
                .then((res) => {
                    Notify('dirty', 'Se agrego el anticipo para la modelo')
                    this.$refs['anticipo'].hide()
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    if (this.typeAnticipo === 'jugueteria') {
                        this.subnominas[index].jugueteria -= parseFloat(res.total)
                        this.subnominas[index].pay_jugueteria -= parseFloat(res.total)
                    } else if (this.typeAnticipo === 'variedades') {
                        this.subnominas[index].variedades -= parseFloat(res.total)
                        this.subnominas[index].pay_variedades -= parseFloat(res.total)
                    } else if (this.typeAnticipo === 'egreso') {
                        this.subnominas[index].multas_total -= parseFloat(res.total)
                        this.subnominas[index].pay_egresos -= parseFloat(res.total)
                    } else if (this.typeAnticipo === 'mecato') {
                        this.subnominas[index].mecato -= parseFloat(res.total)
                    }
                    this.getAnticipos(this.uid_add)
                })
        },
        getEgresoTypes() {
            API.getEgresosTypeList()
                .then((res) => {
                    this.egresoTypes = res
                })
        },
        getIngresosTypes() {
            API.getIngresosTypeList()
                .then((res) => {
                    this.ingresosTypes = res
                })
        },
        getPendingTypes() {
            API.getPendingTypes()
                .then((res) => {
                    this.pendingTypes = res
                })
        },
        getAnticiposTypes() {
            API.getAnticiposTypes()
                .then((res) => {
                    this.anticiposTypes = res
                })
        },
        getAnticiposMedios() {
            API.getAnticiposMedios()
                .then((res) => {
                    this.anticiposMedios = res
                })
        },
        addItem(uid, type) {
            if (type === 'tienda') {
                this.isOpenTienda = true
            } else {
                this.$refs[type].show()
            }
            this.uid_add = uid
        },
        getPlatforms(uid) {
            this.ledgers = []
            API.getPlatformsNomina(uid, this.nomina_id)
                .then((res) => {
                    this.ledgers = res
                })
        },
        detelePending(id, uid) {
            API.detelePendingNomina(uid, this.nomina_id, id)
                .then((res) => {
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    if (res.type === 'jugueteria') {
                        this.subnominas[index].jugueteria -= parseFloat(res.valor)
                        this.subnominas[index].pay_jugueteria -= parseFloat(res.valor)
                    } else if (res.type === 'variedades') {
                        this.subnominas[index].variedades -= parseFloat(res.valor)
                        this.subnominas[index].pay_variedades -= parseFloat(res.valor)
                    } else if (res.type === 'egreso') {
                        this.subnominas[index].multas_total -= parseFloat(res.valor)
                        this.subnominas[index].pay_egresos -= parseFloat(res.valor)
                    }
                    this.getPendings(uid)
                })
        },
        deteleAnticipo(id, uid) {
            API.deteleAnticipoNomina(uid, this.nomina_id, id)
                .then((res) => {
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === this.uid_add)
                    if (res.type === 'jugueteria') {
                        this.subnominas[index].jugueteria += parseFloat(res.valor)
                        this.subnominas[index].pay_jugueteria += parseFloat(res.valor)
                    } else if (res.type === 'variedades') {
                        this.subnominas[index].variedades += parseFloat(res.valor)
                        this.subnominas[index].pay_variedades += parseFloat(res.valor)
                    } else if (res.type === 'egreso') {
                        this.subnominas[index].multas_total += parseFloat(res.valor)
                        this.subnominas[index].pay_egresos += parseFloat(res.valor)
                    } else if (res.type === 'mecato') {
                        this.subnominas[index].mecato -= parseFloat(res.valor)
                    }
                    this.getAnticipos(uid)
                })
        },
        getPendings(uid) {
            this.pendings = []
            API.getPendingNomina(uid, this.nomina_id)
                .then((res) => {
                    this.pendings = res
                })
        },
        getAnticipos(uid) {
            this.anticipos = []
            API.getAnticiposNomina(uid, this.nomina_id)
                .then((res) => {
                    this.anticipos = res
                })
        },
        deleteEgreso(id, uid) {
            API.deleteEgresoNomina(uid, this.nomina_id, id)
                .then((res) => {
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === uid)
                    this.subnominas[index].multas_total -= parseFloat(res.valor)
                    this.subnominas[index].pay_egresos -= parseFloat(res.valor)
                    this.getEgresos(uid)
                })
        },
        deleteIngreso(id, uid) {
            API.deleteIngresoNomina(uid, this.nomina_id, id)
                .then((res) => {
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === uid)
                    this.subnominas[index].ingresos -= parseFloat(res.valor)
                    this.getIngresos(uid)
                })
        },
        getEgresos(uid) {
            this.egresos = []
            API.getEgresosNomina(uid, this.nomina_id)
                .then((res) => {
                    this.egresos = res
                })
        },
        getIngresos(uid) {
            this.ingresos = []
            API.getIngresosNomina(uid, this.nomina_id)
                .then((res) => {
                    this.ingresos = res
                })
        },
        deleteVenta(id, uid) {
            API.deleteVentaNomina(uid, this.nomina_id, id)
                .then((res) => {
                    var index = this.subnominas.findIndex(subnomina => subnomina.uid === uid)
                    if (res.type === 'jugueteria') {
                        this.subnominas[index].jugueteria -= parseFloat(res.total)
                        this.subnominas[index].pay_jugueteria -= parseFloat(res.total)
                    } else if (res.type === 'variedades') {
                        this.subnominas[index].variedades -= parseFloat(res.total)
                        this.subnominas[index].pay_variedades -= parseFloat(res.total)
                    } else if (res.type === 'mecato') {
                        this.subnominas[index].mecato -= parseFloat(res.total)
                    }
                    this.getJugueteria(uid)
                    this.getVariedades(uid)
                    this.getMecato(uid)
                })
        },
        getJugueteria(uid) {
            this.jugueteria = []
            API.getJugueteriaNomina(uid, this.nomina_id)
                .then((res) => {
                    this.jugueteria = res
                })
        },
        getVariedades(uid) {
            this.variedades = []
            API.getVariedadesNomina(uid, this.nomina_id)
                .then((res) => {
                    this.variedades = res
                })
        },
        getMecato(uid) {
            this.mecato = []
            API.getMecatoNomina(uid, this.nomina_id)
                .then((res) => {
                    this.mecato = res
                })
        },
        getLastLedgers(uid) {
            this.lastLedgers = []
            API.getLastLedgersNomina(uid, this.nomina_id)
                .then((res) => {
                    this.lastLedgers = res
                })
        },
        openDetails(uid) {
            this.getPlatforms(uid)
            this.getPendings(uid)
            this.getAnticipos(uid)
            this.getEgresos(uid)
            this.getIngresos(uid)
            this.getJugueteria(uid)
            this.getVariedades(uid)
            this.getMecato(uid)
            this.getLastLedgers(uid)
            if (this.userOpen === uid) {
                this.userOpen = null
                return
            }
            this.userOpen = uid
        },
        addTRM() {
            API.changeTRM(this.nomina_id, this.TRM_TO_SEND)
                .then((res) => {
                    this.$refs.addTRM.hide()
                    this.subnominas = []
                    this.nominas = []
                    this.getNominas()
                })
        },
        EditarNomina() {
            API.editarNomina(this.subnominas, this.nomina_id)
                .then(() => {
                    this.getNominas()
                })
        },
        CerrarNomina() {
            API.CerrarNomina(this.nomina_id)
                .then((res) => {
                    this.getNominas()
                })
        },
        openSubNomina(item) {
            this.subnomina_open = item
            this.$refs.subnomina.show()
            this.getPlatforms(item.uid)
            this.getPendings(item.uid)
            this.getEgresos(item.uid)
            this.getJugueteria(item.uid)
            this.getVariedades(item.uid)
            this.getMecato(item.uid)
            this.totalBongaCamsDolars = 0
            this.totalCamsodaDolars = 0
            this.totalChaturbateDolars = 0
            this.totalSkyprivateDolars = 0
            this.totalStripchatDolars = 0
            API.getPlatformsSubnomina(item.uid, this.nomina_id)
                .then((res) => {
                    res.forEach(info => {
                        if (info.plataforma === 'Bongacams') {
                            this.totalBongaCamsDolars = info.total
                        }
                        if (info.plataforma === 'Camsoda') {
                            this.totalCamsodaDolars = info.total
                        }
                        if (info.plataforma === 'Chaturbate') {
                            this.totalChaturbateDolars = info.total
                        }
                        if (info.plataforma === 'Skyprivate') {
                            this.totalSkyprivateDolars = info.total
                        }
                        if (info.plataforma === 'Stripchat') {
                            this.totalStripchatDolars = info.total
                        }
                    })
                })
        },
        priceFormat: function(value) {
            return Price(value)
        },
        selectedNomina(index) {
            if (this.back_index >= 0) {
                this.nominas[this.back_index].select = false
            }
            this.nomina_id = this.nominas[index].id
            this.nomina_link = this.nominas[index].link
            this.totalPlataformas = this.nominas[index].platforms_total
            this.mecato_total = this.nominas[index].mecato
            this.jugueteria_total = this.nominas[index].jugueteria
            this.variedades_total = this.nominas[index].variedades
            this.egresos_total = this.nominas[index].multas_total
            this.pendientes = this.nominas[index].deben_total
            this.modelBonos = this.nominas[index].bonos_modelos
            this.bono_pesos = this.nominas[index].bono_pesos
            this.bono_dolar = this.nominas[index].bono_dolar
            this.monitorBonos = this.nominas[index].bonos_monitores
            this.adminBonos = this.nominas[index].bonos_administradores
            this.trm = this.nominas[index].trm
            this.status = this.nominas[index].status
            this.nominas[index].select = true
            this.back_index = index
            this.intervalDate = this.nominas[index].start.split(this.$store.state.constants.SEPARETOR)[0] + ' - ' + this.nominas[index].finish.split(this.$store.state.constants.SEPARETOR)[0]
            this.subnominas = this.nominas[index].subnominas
        },
        getNominas() {
            API.getNominas()
                .then((res) => {
                    if (res.length === 0) {
                        return
                    }
                    this.nominas = res
                    var index
                    if (!this.nomina_id) {
                        this.nomina_id = this.nominas[0].id
                        index = 0
                    } else {
                        index = this.nominas.findIndex(object => { return object.id === this.nomina_id })
                    }
                    this.selectedNomina(index)
                })
        }
    },
    mounted() {
        this.getAnticiposTypes()
        this.getAnticiposMedios()
        this.getEgresoTypes()
        this.getIngresosTypes()
        this.getNominas()
        this.getPendingTypes()
        this.getCategoriesList()
    }
}
</script>

<style scoped>
    .sendwpp {
        position: absolute;
        right: 30px;
        top: 15px;
        background-color: #e0b059;
        color: #fff;
        padding: 10px;
        border-radius: 20px;
        border-color: #fff;
    }
    .nomina {
        background-color: #cdcdcd;
        height: 90vh;
        color: #000;
        display: flex;
        position: relative;
    }
    .nomina > .wait {
        height: 500px;
        width: 500px;
        position: fixed;
        background-color: #2b2926;
        z-index: 9999;
        border-style: double;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
    }
    .nomina > .wait > div {
        width: 100%;
        height: 100%;
    }
    .nomina > .wait > div > img {
        width: 100%;
        height: 100%;
    }
    .animation {
        animation-name: fade;
        animation-duration: 4.5s;
    }
    .nomina > .display{
        display: none;
    }
    .nomina > div.modal-list {
        padding: 40px;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 999;
        border-radius: 0px;
    }
    .nomina > div.modal-list > div{
        background-color: #FFF;
        height: 100%;
        width: 100%;
        padding: 20px;
        color: #000;
        position: relative;
    }
    .nomina > div.modal-list > div > div.products-info {
        width: 100%;
        height: 90%;
        display: flex;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido{
        padding: 50px;
        width: 100%;
        height: 80%;
        overflow: auto;
    }
    .nomina > div.modal-list > div > div.products-info > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div{
        width: 100%;
        height: 100px;
        margin-bottom: 20px;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center {
        width: 100%;
        background-color: #2b2926;
        padding: 10px;
        height: 100%;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center > div {
        width: 18%;
        height: 100%;
        text-align: center;
        color: #FFF;
        display: inline-block;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center > div > img {
        width: 50%;
        height: 100%;
        object-fit: cover;
        display: inline-block;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center > div > h5 {
        width: 100%;
        color: #FFF;
        text-align: center;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center > div > input {
        width: 80px;
        height: 40px;
        text-align: center;
    }
    .nomina > div.modal-list > div > div.products-info > .list-pedido > div > center > div > label {
        width: 150px;
    }
    .nomina > div.modal-list > div > div.products-info > .products-list{
       padding: 50px;
       width: 100%;
       height: 95%;
       overflow: auto;
    }
    .nomina > div.modal-list > div > div.products-info > .products-list > div{
       width: 27%;
       display: inline-block;
       height: 350px;
       position: relative;
       background-color: #2b2926;
       margin: 20px;
    }
    .nomina > div.modal-list > div > div.products-info > .products-list > div > center {
        width: 100%;
        padding: 20px;
        color: #FFF;
    }
    .nomina > div.modal-list > div > div.products-info > .products-list > div > center > img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 30px;
    }
    .nomina > div.modal-list > div > div.products-info > .category-list{
       padding: 50px;
       width: 100%;
       height: 95%;
       overflow: auto;
    }
    .nomina > div.modal-list > div > div.products-info > .category-list > div{
       width: 27%;
       display: inline-block;
       height: 150px;
       position: relative;
       background-color: #2b2926;
       margin: 20px;
    }
    .nomina > div.modal-list > div > div.products-info > .category-list > div > label {
        position: absolute;
        color: #FFF;
        font-weight: bolder;
        font-size: 20;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .nomina > div.modal-list > div > div.products-info > div.model-info {
        width: 30%;
        height: 100%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .nomina > div.modal-list > div > div.products-info > div.model-info > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .nomina > div.modal-list > div > div.products-info > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .nomina > div.modal-list > div > div.products-info > div.model-info > div {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .nomina > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .nomina > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .nomina > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .nomina > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .nomina > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .nomina > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .nomina > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .nomina > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .nomina > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .nomina > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .nomina > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .nomina > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 200px;
        height: 200px;
        object-fit: cover;
    }
    .nomina > center >.prenomina{
        position: absolute;
        background-color: turquoise;
        z-index: 99;
        width: 100%;
        height: 97%;
        overflow: auto;
        padding: 40px;
        border-radius: 20px;
    }
    .nomina > center > .prenomina > div {
        position: fixed;
        bottom: 20px;
        /* top: 20px; */
        cursor: pointer;
        width: 100%;
    }
    .nomina > center > .prenomina > div.close {
        position: fixed;
        top: 100px;
        right: 36px;
        cursor: pointer;
        width: 10px;
        height: 10px;
        z-index: 9999;
    }
    .nomina > center > .prenomina > div > button {
        color: #fff;
        background-color: #e0b059;
        padding: 20px;
        border-radius: 20px;
        border-color: #fff;
        width: 300px;
    }
    .nomina > center > .prenomina > table > thead > tr > th {
        padding: 10px;
        background-color: #e0b059;
        text-align: center;
        position: sticky; top: 0; z-index: 1;
        z-index: 999;
    }
    .nomina > center> .prenomina > table > tbody > tr.modelo {
        background-color: aqua;
    }
    .nomina > center> .prenomina > table > tbody > tr.no-pay {
        background-color: red;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td {
        padding: 10px;
        text-align: center;
        border-style: inset;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > button {
        background-color: #e0b059;
        text-align: center;
        position: sticky; top: 0; z-index: 1;
        border-radius: 50%;
    }
    .nomina > center > .prenomina > table > tbody > tr > td > img {
        width: 50px;
        height: 50px;
        object-fit: cover;
        border-radius: 50%;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > button {
        background-color: #e0b059;
        color: #fff;
        padding: 10px;
        border-radius: 20px;
        border-color: #fff;
    }
    table  { border-collapse: collapse; width: 100%; }
    th, td { padding: 8px 16px; }
    th     { background:#eee; }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > button {
        background-color: #e0b059;
        color: #fff;
        padding: 10px;
        border-radius: 20px;
        border-color: #fff;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > thead > tr > th{
        padding: 30px;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > tbody > .total {
        background-color: #8363b7;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td{
        padding-left: 30px;
        padding-right: 30px;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td > h5{
        cursor: pointer;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td > h5:hover{
        color: red;
    }
    .nomina > center> .prenomina > table > tbody > tr >  td > center > .active {
        background-color: #fff;
        color: #e0b059;
        padding: 10px;
        border-radius: 20px;
        border-color: #e0b059;
    }
    .nomina > .notifications {
        width: 60%;
        height: 100%;
    }
    .nomina > .notifications > .table{
        width: 100%;
        height: 60%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #63b1b7;
    }
    .nomina > .notifications > .table > center {
        width: 100%;
        overflow: auto;
        height: 100%;
    }
    .nomina > .notifications > .table > center > h3 {
        color: #fff;
    }
    .nomina > .notifications > .table > center > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 30px;
        position: relative;
        width: 90%;
    }
    .nomina > .notifications > .table > center > .select {
        background-color: #22bb33;
    }
    .nomina > .notifications > .table > center > div > label {
        width: 20%;
    }
    .nomina > .notifications > .details{
        width: 100%;
        height: 38%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
        background-color: #8363b7;
    }
    .nomina > .notifications > .details > div {
        display: flex;
        width: 100%;
    }
    .nomina > .notifications > .details > div > div{
        width: 33%;
        display: grid;
    }
    .nomina > .notifications > .details > div > div > label{
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        display: grid;
        text-align: center;
    }
    .nomina > .notifications > .details > div > div > p{
        font-size: 20px;
        color: #000;
        float: right;
        padding-right: 30px;
        background-color: #fff;
        text-align: center;
        border-radius: 20px;
    }
    .nomina > .notifications > .details > div > div > label > span{
        font-size: 18px;
        color: #000;
        float: right;
        padding-right: 30px;
        text-transform: capitalize;
    }
    .nomina > .notifications > .details > center > h3 {
        color: #fff;
        background-color: #2b2926;
    }
    .nomina > .models {
        width: 40%;
        height: 100%;
        padding-left: 20px;
    }
    .nomina > .models > .list > center > h3 {
        color: #fff;
    }
    .nomina > .models > .list{
        width: 100%;
        height: 80%;
        border-radius: 20px;
        border-style: outset;
        padding: 20px;
        background-color: #585858;
        overflow-y: auto;
    }
    .nomina > .models > .list > div{
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 100px;
        position: relative;
        display: flex;
        padding: 10px 40px;
        cursor: pointer;
    }
    .nomina > .models > .list > div > img{
        width: 80px;
        height: 80px;
        object-fit: cover;
        margin-right: 60px;
        border-radius: 50%;
    }
    .nomina > .models > .list  > div > div {
        display: grid;
        text-align: left;
    }
    .nomina > .models > .list > div > label{
        width: 49%;
        text-align: center;
        padding: 3px;
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    .nomina > .models > .list > div > label >.vista{
        background-color: #22bb33;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .nomina > .models > .list > div > label > .entregada {
        background-color: #63b1b7;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .nomina > .models > .functions{
        width: 100%;
        height: 20%;
        padding-left: 20px;
        padding: 10px;
        float: left;
    }
    .nomina > .models > .functions> div {
        background-color: #63b1b7;
        width: 100%;
        height: 50%;
        display: flex;
    }
    .nomina > .models > .functions> div > div{
        background-color: #63b1b7;
        width: 50%;
        height: 50%;
        position: relative;
        padding: 35px;
    }
    .nomina > .models > .functions> div > div > button{
        position: absolute;
        background-color: #e0b059;
        color: #fff;
        padding: 10px;
        border-radius: 20px;
        border-color: #fff;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .info-wrapper {
        padding: 60px;
    }
    .info-wrapper > h3 {
        margin: 60px;
    }
    .info-wrapper > input {
        width: 300px;
        height: 40px;
        border-radius: 20px;
        margin: 30px;
        text-align: center;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        padding: 10px;
        border-radius: 20px;
        border-color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue